import React from "react";

// Simple placeholder logo for Authentic Kitchen — a serif "AK." mark
// paired with a small flame accent. Easy to replace later.
export const Logo = ({ size = "default", showWord = true }) => {
  const dim = size === "lg" ? "h-12" : "h-9";
  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className="flex items-center gap-3 group"
      aria-label="Authentic Kitchen home"
    >
      <span
        className={`relative inline-flex items-center justify-center ${dim} aspect-square`}
      >
        <span className="absolute inset-0 rounded-sm border border-orange-500/70 group-hover:border-orange-400 transition-colors" />
        <span className="absolute inset-[3px] rounded-[2px] bg-stone-950" />
        <span className="relative font-serif-display text-stone-50 text-xl leading-none tracking-tight">
          A<span className="text-orange-500">K</span>
          <span className="text-orange-500">.</span>
        </span>
      </span>
      {showWord && (
        <span className="hidden sm:flex font-proxima leading-none">
          <span className="text-stone-50 text-base sm:text-lg font-semibold tracking-[0.14em] uppercase">
            Authentic Kitchen
          </span>
        </span>
      )}
    </a>
  );
};

export default Logo;
